import { T, useT } from '@transifex/react';
import { Text, VStack } from '@vidahealth/vida-ui';
import LottieView from 'lottie-react-native';
import { StyleSheet, View } from 'react-native';

import lineChartLottie from '@/assets/lotties/line-chart-gilbert.json';
import { useRulesEngine } from '@/modules/rulesEngine';
import { CtaButton, Screen, ScreenHeading } from '@/modules/ui';

/**
 * TESTIMONIAL — the optional "outcomes before coach selection" page shown after
 * enrolling a qualifying program (gated by shouldShowTestimonial). Mirrors
 * stylos's Onboarding.TestimonialPage: a line-chart Lottie + a member quote.
 * Continue ("Choose Your Health Coach") dismisses it and the driver advances to
 * coach matching.
 */
export function TestimonialScreen() {
  const t = useT();
  const { dismissTestimonial } = useRulesEngine();

  return (
    <Screen
      footer={
        <CtaButton onPress={dismissTestimonial} testID='testimonial-continue'>
          <T _str='Choose Your Health Coach' />
        </CtaButton>
      }
    >
      <VStack space='2xl'>
        <ScreenHeading title={t('The right health coach can make all the difference')} />
        <View style={styles.lottieCard}>
          <LottieView
            source={lineChartLottie}
            autoPlay
            loop
            resizeMode='cover'
            style={styles.lottie}
          />
        </View>
        <VStack space='xs'>
          <Text size='lg' className='font-body-semibold text-typography-900'>
            <T _str='My coaches helped me learn how to eat better, stay active, and completely change my life.' />
          </Text>
          <Text size='md' className='text-typography-700'>
            <T _str='-{user}, Vida member' user='Gilbert' />
          </Text>
        </VStack>
      </VStack>
    </Screen>
  );
}

const styles = StyleSheet.create({
  // The CONTAINER owns the size: full content width at the Lottie's native 4:3
  // (600×450) ratio, with the rounded clip (stylos wraps it in a Card).
  lottieCard: {
    width: '100%',
    alignSelf: 'stretch',
    aspectRatio: 4 / 3,
    borderRadius: 12,
    overflow: 'hidden',
  },
  // Absolutely fill the container so the Lottie's intrinsic 600×450 size doesn't
  // drive layout — otherwise (in normal flow) it fights the container's
  // width/aspectRatio and the box renders at the wrong size on web.
  lottie: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});
